import { formatDate } from 'element-ui/lib/utils/date-util'

// Extra room for the caret and for years or digits slightly wider than the sampled ones
const SLACK_PX = 6

let ctx = null

// Width of the widest text an Element date picker shows for a display format: every month and
// weekday on a two-digit day, formatted by Element itself so the text matches the picker's.
function widestText(format, font, letterSpacing) {
  if (!ctx) ctx = document.createElement('canvas').getContext('2d')
  if (!ctx) return 0
  ctx.font = font
  const year = new Date().getFullYear()
  let widest = 0
  for (let month = 0; month < 12; month++) {
    // 22 to 28: two-digit days that cover every weekday
    for (let day = 22; day <= 28; day++) {
      const text = formatDate(new Date(year, month, day), format)
      widest = Math.max(widest, ctx.measureText(text).width + text.length * letterSpacing)
    }
  }
  return widest
}

/**
 * Pixel width for a date picker input that fits the widest date its display format can
 * produce (weekday prefix, long month names), so the box suits the group's date format and
 * keeps one size from date to date. Reads the font and padding from the rendered input.
 * Returns null when it cannot measure; callers keep their default width.
 */
export function fitDateInputWidth(inputEl, format) {
  if (!inputEl || !format || typeof window === 'undefined') return null
  try {
    const cs = window.getComputedStyle(inputEl)
    const px = value => parseFloat(value) || 0
    const font = `${cs.fontStyle} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`
    const text = widestText(format, font, px(cs.letterSpacing))
    if (!text) return null
    return Math.ceil(
      text + px(cs.paddingLeft) + px(cs.paddingRight) + px(cs.borderLeftWidth) + px(cs.borderRightWidth)
    ) + SLACK_PX
  } catch (e) {
    return null
  }
}
